import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgErrorIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 68,
	height: 68,
	viewBox: "0 0 68 68",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter0_ddi_11278_110995)",
			children: /* @__PURE__ */ _jsx("ellipse", {
				cx: 35.9999,
				cy: 35.8023,
				rx: 21.6308,
				ry: 20.9753,
				fill: "url(#paint0_linear_11278_110995)"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M35.999 24.5736L35.999 38.7664",
			stroke: "white",
			strokeWidth: 3.22266
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M35.999 42.7865L35.999 46.2008",
			stroke: "white",
			strokeWidth: 3.22266
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("filter", {
			id: "filter0_ddi_11278_110995",
			x: .369141,
			y: .826996,
			width: 67.4617,
			height: 67.1507,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", {
					dx: -6,
					dy: -6
				}),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 4 }),
				/* @__PURE__ */ _jsx("feComposite", {
					in2: "hardAlpha",
					operator: "out"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "BackgroundImageFix",
					result: "effect1_dropShadow_11278_110995"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feMorphology", {
					radius: 1,
					operator: "erode",
					in: "SourceAlpha",
					result: "effect2_dropShadow_11278_110995"
				}),
				/* @__PURE__ */ _jsx("feOffset", {
					dx: 3,
					dy: 4
				}),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 4.1 }),
				/* @__PURE__ */ _jsx("feComposite", {
					in2: "hardAlpha",
					operator: "out"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0.117647 0 0 0 0 0.160784 0 0 0 0 0.231373 0 0 0 0.2 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "effect1_dropShadow_11278_110995",
					result: "effect2_dropShadow_11278_110995"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "effect2_dropShadow_11278_110995",
					result: "shape"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", {
					dx: 1,
					dy: 1
				}),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 2 }),
				/* @__PURE__ */ _jsx("feComposite", {
					in2: "hardAlpha",
					operator: "arithmetic",
					k2: -1,
					k3: 1
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "shape",
					result: "effect3_innerShadow_11278_110995"
				})
			]
		}), /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_11278_110995",
			x1: 17.3354,
			y1: 19.2723,
			x2: 58.8182,
			y2: 68.9491,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#FF6565" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#D00F0F"
			})]
		})] })
	]
});
export default SvgErrorIcon;
